import { render, staticRenderFns } from "./detail_one.vue?vue&type=template&id=11b16f0e&scoped=true&"
import script from "./detail_one.vue?vue&type=script&lang=js&"
export * from "./detail_one.vue?vue&type=script&lang=js&"
import style0 from "./detail_one.vue?vue&type=style&index=0&id=11b16f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b16f0e",
  null
  
)

export default component.exports